import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export function PipIcon(props: SvgIconProps) {
  return (
    <SvgIcon width='18' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M19 4a3 3 0 0 1 3 3v4a1 1 0 0 1 -2 0V7a1 1 0 0 0 -1 -1H5a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1h6a1 1 0 0 1 0 2H5a3 3 0 0 1 -3 -3V7a3 3 0 0 1 3 -3z'
        fill='currentColor'
      />
      <path d='M20 13a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-5a2 2 0 0 1 -2 -2v-3a2 2 0 0 1 2 -2z' fill='currentColor' />
    </SvgIcon>
  );
}
